module.exports = __webpack_public_path__ + "static/media/LG 7_18sec.34f2301c.mp3";